import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'

/**
 * Reloads config after a successful upsert so backend truth is re-read
 */
export const reloadOnUpsertSuccess = store.effects.create((feature: Feature) =>
  feature.actions.upsert.success
    .observe()
    .pipe(rxjs.map(action => feature.actions.load.from(action).create())),
)
